import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import loginPageSlice from "../../login-page/store/slice";
import { Role } from "../../users/store/slice";
import roleSlice from "./slice";

type RolesResponse = ApiResponse<{ data: Role[] }>;

function* roleSaga() {
  yield takeLatest(loginPageSlice.actions.setLoggedIn, handleFetch);
}

function* handleFetch() {
  const response: RolesResponse = yield call(fetchAPI, "/roles");

  if (response && response.data) {
    yield put(roleSlice.actions.setData(response.data));
  }

  yield put(roleSlice.actions.setIsLoading(false));
}

export default roleSaga;
